export const ENCOUNTER_TYPE = {
  REGULAR: "REGULAR",
  FOLLOW_UP: "FOLLOW_UP",
};
